"use strict";
/**
 * Copyright 2023 actions-toolkit authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Builder = void 0;
const buildx_1 = require("./buildx");
const exec_1 = require("../exec");
class Builder {
    constructor(opts) {
        this.buildx = (opts === null || opts === void 0 ? void 0 : opts.buildx) || new buildx_1.Buildx();
    }
    inspect(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const cmd = yield this.buildx.getCommand(['inspect', name]);
            return yield exec_1.Exec.getExecOutput(cmd.command, cmd.args, {
                ignoreReturnCode: true,
                silent: true
            }).then(res => {
                if (res.stderr.length > 0 && res.exitCode != 0) {
                    throw new Error(res.stderr.trim());
                }
                return Builder.parseInspect(res.stdout);
            });
        });
    }
    static parseInspect(data) {
        const builder = {
            nodes: []
        };
        let node = {};
        for (const line of data.trim().split(`\n`)) {
            const [key, ...rest] = line.split(':');
            const value = rest.map(v => v.trim()).join(':');
            if (key.length == 0 || value.length == 0) {
                continue;
            }
            switch (key.toLowerCase()) {
                case 'name': {
                    if (builder.name == undefined) {
                        builder.name = value;
                    }
                    else {
                        if (Object.keys(node).length > 0) {
                            builder.nodes.push(node);
                            node = {};
                        }
                        node.name = value;
                    }
                    break;
                }
                case 'driver': {
                    builder.driver = value;
                    break;
                }
                case 'last activity': {
                    builder.lastActivity = new Date(value);
                    break;
                }
                case 'endpoint': {
                    node.endpoint = value;
                    break;
                }
                case 'driver options': {
                    node['driver-opts'] = (value.match(/(\w+)="([^"]*)"/g) || []).map(v => v.replace(/^(.*)="(.*)"$/g, '$1=$2'));
                    break;
                }
                case 'status': {
                    node.status = value;
                    break;
                }
                case 'flags': {
                    node['buildkitd-flags'] = value;
                    break;
                }
                case 'buildkit': {
                    node.buildkit = value;
                    break;
                }
                case 'platforms': {
                    let platforms = [];
                    // if a preferred platform is being set then use only these
                    // https://docs.docker.com/engine/reference/commandline/buildx_inspect/#get-information-about-a-builder-instance
                    if (value.includes('*')) {
                        for (const platform of value.split(', ')) {
                            if (platform.includes('*')) {
                                platforms.push(platform.replace('*', ''));
                            }
                        }
                    }
                    else {
                        // otherwise set all platforms available
                        platforms = value.split(', ');
                    }
                    node.platforms = platforms.join(',');
                    break;
                }
            }
        }
        if (Object.keys(node).length > 0) {
            builder.nodes.push(node);
        }
        return builder;
    }
}
exports.Builder = Builder;
//# sourceMappingURL=builder.js.map